module.exports = __webpack_public_path__ + "static/media/lena.97d3b8b0.jpg";